/* eslint-disable no-confusing-arrow */
import styled from 'styled-components';
import { Container } from '../../../../ui/gridSystem';

export const HomeBanner = styled.div`
  width: var(--full-width);
  height: 250px;
  position: relative;
`;

export const BackgroundImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 250px;
  z-index: -1;
`;

export const HomeBannerContainer = styled(Container)`
  padding: 50px 0;
  padding-right: 0 !important;
  padding-left: 0 !important;
  height: 100%;

  @media ${(props) => props.theme.device.tabletL} {
    width: 100%;
    padding-left: 20px !important;
  }
`;

export const Greetings = styled.div`
  color: ${({ theme }) => theme.colors.textPrimary};
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  gap: 26px;
`;

export const AsideBlock = styled.div`
  background-color: ${({ theme }) => theme.colors.aside};
  padding: 0 16px 36px;
  border-radius: 0 0 0 4px;
  margin-bottom: 3rem;

  & > h3 {
    padding-top: 1.5rem;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 21px;
    margin-bottom: 16px;
  }

  & > p {
    margin-bottom: 1.5rem;
  }

  &.secondary {
    background-color: transparent;
    border-radius: 0;
    padding-bottom: 0;

    &.links {
      border: none;
      padding-right: calc(3rem - 15px);
    }

    & > h3 {
      padding-top: 0;
      margin-bottom: 0;
    }
  }

  //CTA "tutti i tuoi progressi"
  //CTA "tutti i documenti"
  > button {
    margin-top: 24px;
  }
`;

export const LinksWrapper = styled.div`
  max-height: 170px;
  padding-right: 15px;
  overflow-y: auto;
  transition: ${({ theme }) => theme.constants.transitionBase};

  > a {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 0;
    color: ${({ theme }) => theme.colors.link};
    border-bottom: 0.5px solid #8b8b8b;

    &:hover {
      color: ${({ theme }) => theme.colors.btnHover};
      svg {
        stroke: ${({ theme }) => theme.colors.btnHover};
      }
    }
  }
`;

export const Progress = styled.div`
  position: relative;
  max-width: 400px;
  margin: auto;
  padding-bottom: min(75%, 270px);

  .chart-wrapper {
    width: 74%;
    position: absolute;
    left: 13%;
    top: -65px;
    z-index: 1;

    canvas {
      width: 100% !important;
      height: auto !important;
    }
  }
`;

export const Ellipse = styled.img`
  width: 40%;
  position: absolute;
  height: auto;
  left: 30%;
  bottom: 130px;
`;

export const TotalCourses = styled.div`
  width: 100%;
  position: absolute;
  height: auto;
  left: 0;
  bottom: 150px;
  text-align: center;

  h2 {
    font-weight: 700;
    font-size: 17.4181px;
    line-height: 26px;
  }

  > div.b3 {
    font-weight: 400;
    font-size: 9px;
    line-height: 12px;
  }
`;

export const CarouselHeader = styled(Container)`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 16px;

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }
`;

export const CarouselTitle = styled.div``;

export const Icon = styled.div`
  font-weight: bold !important;
`;

export const SecondaryContainer = styled.div`
  padding: 50px 0;
  background-color: ${(props) =>
    props.isEven
      ? props.theme.colors.bgSecondary
      : props.theme.colors.bgPrimary};
`;

export const HomeContainer = styled.div`
  position: relative;

  .home-container {
    padding-right: 32px;
    padding-left: 32px;
  }
`;

export const ProgressWrapper = styled.div`
  max-width: 100%;
  position: relative;
  padding-bottom: max(calc(60% + 50px), 240px);
  height: 0;
  margin-bottom: 34px;

  & > svg {
    display: block;
    position: absolute;
    width: 60%;
    left: 20%;
    top: 30px;
  }
`;

export const Percentage = styled.div`
  position: absolute;
  margin: 0 auto;
  top: 70px;
  text-align: center;
  width: 100%;
  left: 0;
  font-size: 32px;
  font-weight: 600;
`;

export const ProgressInfo = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 4px;
  position: absolute;
  bottom: 0;
  width: 100%;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  row-gap: 6px;
  column-gap: 23px;
  padding: 20px 30px;

  > div {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 8px;
    max-width: calc((100% - 32px) / 3);

    .b5 {
      font-size: 12px;
      width: 100%;
    }

    .legend {
      width: 100%;
      height: 10px;
      border-radius: 2px;
      align-self: end;

      &.completed {
        background-color: ${({ theme }) => theme.colors.completedColor};
      }
      &.incomplete {
        background-color: ${({ theme }) => theme.colors.incompleteColor};
      }
      &.mandatory-course {
        background-color: ${({ theme }) => theme.colors.mandatory};
      }
    }
  }

  @media ${(props) => props.theme.device.mobileM} {
    gap: 12px;
  }
`;
